import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SagePage from "./pages/SagePage.jsx";
import LedgerPage from "./pages/LedgerPage.jsx";
import OpenGatePage from "./pages/OpenGatePage.jsx";
import PhilanthropyPage from "./pages/PhilanthropyPage.jsx";
import TermsPage from "./pages/TermsPage.jsx";
import PrivacyPage from "./pages/PrivacyPage.jsx";
import AdminPage from "./pages/AdminPage.jsx";
import SeedPage from "./pages/SeedPage.jsx";
import OvenPage from "./pages/OvenPage.jsx";
import PromisesPage from "./pages/PromisesPage.jsx";
import PersonaPage from "./pages/PersonaPage.jsx";
import AdminPoolsPage from "./pages/AdminPoolsPage.jsx";
import ProductsPage from "./pages/ProductsPage.jsx";
import ManualPage from "./pages/ManualPage.jsx";
import LossesPage from "./pages/LossesPage.jsx";
import LibraryPage from "./pages/LibraryPage.jsx";
import LibraryShelfPage from "./pages/LibraryShelfPage.jsx";
import ProposalsPage from "./pages/ProposalsPage.jsx";  // legacy — page still routable at /proposals but no longer linked in nav (14-day mechanic retired)
import TiersPage from "./pages/TiersPage.jsx";
import PaymentSuccessPage from "./pages/PaymentSuccessPage.jsx";
import PaymentCancelPage from "./pages/PaymentCancelPage.jsx";
import QuillPage from "./pages/QuillPage.jsx";
import LoomPage from "./pages/LoomPage.jsx";
import PersonaScrollEditorPage from "./pages/PersonaScrollEditorPage.jsx";
import FounderLoginPage from "./pages/FounderLoginPage.jsx";
import AuthCallbackPage from "./pages/AuthCallbackPage.jsx";
import PostmasterPage from "./pages/PostmasterPage.jsx";
import AdSmithPage from "./pages/AdSmithPage.jsx";
import HeraldPage from "./pages/HeraldPage.jsx";
import InvestorNotesPage from "./pages/InvestorNotesPage.jsx";
import RiceTheWorldPage from "./pages/RiceTheWorldPage.jsx";
import BrotherhoodPage from "./pages/BrotherhoodPage.jsx";
import BundlesPage from "./pages/BundlesPage.jsx";
import HardshipPage from "./pages/HardshipPage.jsx";
import AgentsPage from "./pages/AgentsPage.jsx";
import WalletPage from "./pages/WalletPage.jsx";
import TinyHomesPage from "./pages/TinyHomesPage.jsx";
import TinyHomesProposalsPage from "./pages/TinyHomesProposalsPage.jsx";
import BrainPage from "./pages/BrainPage.jsx";
import MusicStudioPage from "./pages/MusicStudioPage.jsx";
import MenderPage from "./pages/MenderPage.jsx";
import QuillAuthorshipPage from "./pages/QuillAuthorshipPage.jsx";
import FreeWallPage from "./pages/FreeWallPage.jsx";
import PurserPage from "./pages/PurserPage.jsx";
import VidSmithPage from "./pages/VidSmithPage.jsx";
import BeaconPage from "./pages/BeaconPage.jsx";
import MedicPage from "./pages/MedicPage.jsx";
import CompassPage from "./pages/CompassPage.jsx";
import StewardPage from "./pages/StewardPage.jsx";
import AlmonerPage from "./pages/AlmonerPage.jsx";
import LegalPage from "./pages/LegalPage.jsx";
import StadiumSeatPage from "./pages/StadiumSeatPage.jsx";
import WhistleblowerPage from "./pages/WhistleblowerPage.jsx";
import WhistleblowerAdminPage from "./pages/WhistleblowerAdminPage.jsx";
import BakerLitePage from "./pages/BakerLitePage.jsx";
import BakerLiteRecentPage from "./pages/BakerLiteRecentPage.jsx";
import BakerPage from "./pages/BakerPage.jsx";
import FounderHimselfPage from "./pages/FounderHimselfPage.jsx";
import MentalHealthcarePage from "./pages/MentalHealthcarePage.jsx";
import LegalAdvicePage from "./pages/LegalAdvicePage.jsx";
import EnterprisePage from "./pages/EnterprisePage.jsx";
import SupportWidget from "./components/SupportWidget.jsx";
import BundleButton from "./components/BundleButton.jsx";
import MasterUnlockGate from "./components/MasterUnlockGate.jsx";
import BalanceFloorBanner from "./components/BalanceFloorBanner.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import { isMaster } from "./lib/api";

function RequireMaster({ children }) {
  if (!isMaster()) return <Navigate to="/founder-login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0e0c",
            border: "1px solid #10231a",
            color: "#e4ece7",
            borderRadius: 0,
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          },
        }}
      />
      <MasterUnlockGate />
      <BalanceFloorBanner />
      <Routes>
        {/* Root now lands on Chat. Landing waitlist + /toaster front door retired 2026-08-02. */}
        {/* Founder ruling 2026-08-11 late-evening · visibility bug fix.
            Anonymous visitors landing on the naked domain now hit the public
            Products page — every family-shelf item on view — instead of being
            bounced to /sage which required master login. */}
        <Route path="/" element={<Navigate to="/products" replace />} />
        <Route path="/founder-login" element={<FounderLoginPage />} />
        <Route path="/auth-callback" element={<AuthCallbackPage />} />
        <Route path="/sage-ledger" element={<LedgerPage />} />
        <Route path="/ledger" element={<Navigate to="/sage-ledger" replace />} />
        <Route path="/sage-ledger/losses" element={<LossesPage />} />
        <Route path="/open-gate" element={<OpenGatePage />} />
        <Route path="/philanthropy" element={<PhilanthropyPage />} />
        <Route path="/where-the-coins-go" element={<Navigate to="/philanthropy" replace />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/sage" element={<RequireMaster><SagePage /></RequireMaster>} />
        <Route path="/seed" element={<RequireMaster><SeedPage /></RequireMaster>} />
        <Route path="/promises" element={<PromisesPage />} />
        <Route path="/persona" element={<PersonaPage />} />
        <Route path="/admin/pools" element={<RequireMaster><AdminPoolsPage /></RequireMaster>} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/manual" element={<ManualPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/library/:slug" element={<LibraryShelfPage />} />
        <Route path="/proposals" element={<ProposalsPage />} />
        <Route path="/tiers" element={<TiersPage />} />
        <Route path="/quill" element={<QuillPage />} />
        <Route path="/loom" element={<LoomPage />} />
        <Route path="/postmaster" element={<PostmasterPage />} />
        <Route path="/adsmith" element={<AdSmithPage />} />
        <Route path="/marquee" element={<Navigate to="/adsmith" replace />} />
        <Route path="/herald" element={<HeraldPage />} />
        <Route path="/investor-notes" element={<InvestorNotesPage />} />
        <Route path="/rice-the-world" element={<RiceTheWorldPage />} />
        <Route path="/rice" element={<Navigate to="/rice-the-world" replace />} />
        <Route path="/brotherhood" element={<BrotherhoodPage />} />
        <Route path="/misfits" element={<Navigate to="/brotherhood" replace />} />
        <Route path="/bundles" element={<BundlesPage />} />
        <Route path="/hardship" element={<HardshipPage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/tiny-homes" element={<TinyHomesPage />} />
        <Route path="/tiny-homes/proposals" element={<TinyHomesProposalsPage />} />
        <Route path="/tinyhomes" element={<Navigate to="/tiny-homes" replace />} />
        <Route path="/brain" element={<BrainPage />} />
        <Route path="/studio" element={<MusicStudioPage />} />
        <Route path="/music-studio" element={<MusicStudioPage />} />
        <Route path="/mender" element={<MenderPage />} />
        <Route path="/insurance" element={<Navigate to="/mender" replace />} />
        <Route path="/purser" element={<PurserPage />} />
        <Route path="/vidsmith" element={<VidSmithPage />} />
        <Route path="/beacon" element={<BeaconPage />} />
        <Route path="/medic" element={<MedicPage />} />
        <Route path="/compass" element={<CompassPage />} />
        <Route path="/steward" element={<StewardPage />} />
        <Route path="/almoner" element={<AlmonerPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/stadium-seat" element={<StadiumSeatPage />} />
        <Route path="/stadium" element={<Navigate to="/stadium-seat" replace />} />
        <Route path="/free" element={<FreeWallPage />} />
        <Route path="/free/mental-healthcare" element={<MentalHealthcarePage />} />
        <Route path="/mental-healthcare" element={<Navigate to="/free/mental-healthcare" replace />} />
        <Route path="/whistleblower" element={<WhistleblowerPage />} />
        <Route path="/whistleblower/queue" element={<WhistleblowerAdminPage />} />
        <Route path="/baker-lite" element={<BakerLitePage />} />
        <Route path="/baker-lite/recent" element={<RequireMaster><BakerLiteRecentPage /></RequireMaster>} />
        <Route path="/baker" element={<OvenPage />} />
        <Route path="/baker/workshop" element={<RequireMaster><BakerPage /></RequireMaster>} />
        <Route path="/founder-himself" element={<FounderHimselfPage />} />
        <Route path="/legal-advice" element={<LegalAdvicePage />} />
        <Route path="/enterprise" element={<EnterprisePage />} />
        <Route path="/oven" element={<Navigate to="/baker" replace />} />
        <Route path="/knowledge" element={<Navigate to="/brain" replace />} />
        <Route path="/education" element={<Navigate to="/brain" replace />} />
        <Route path="/quill/authorship" element={<QuillAuthorshipPage />} />
        <Route path="/authorship" element={<Navigate to="/quill/authorship" replace />} />
        <Route path="/self-seed" element={<Navigate to="/investor-notes" replace />} />
        <Route path="/bell" element={<Navigate to="/postmaster" replace />} />
        <Route path="/torch" element={<Navigate to="/adsmith" replace />} />
        <Route path="/scroll-editor" element={<RequireMaster><PersonaScrollEditorPage /></RequireMaster>} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
        <Route path="/admin" element={<RequireMaster><AdminPage /></RequireMaster>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <SupportWidget />
      <BundleButton />
    </BrowserRouter>
  );
}
